<template>
  <div class="grid-universal-footer">
    <component :is="ctaComponent" v-if="isCtaShowing && !isParticipantEmbed" />
  </div>
</template>

<script>
import AudienceCTAContainer from '@/containers/footer/AudienceCTA'
import { mapGetters } from 'vuex'
import AudienceCTA from '@/components/footer/AudienceCTA.vue'
import DsAudienceFooter from '@/components/footer/DsAudienceFooter.vue'

export default {
  components: {
    AudienceCTA: AudienceCTAContainer(AudienceCTA),
    DsAudienceFooter,
  },
  props: {
    isCtaShowing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('participantEmbed', ['isParticipantEmbed']),
    ...mapGetters('replay', { isDsFooterEnabled: 'isEnabled' }),
    ctaComponent() {
      return this.isDsFooterEnabled ? 'DsAudienceFooter' : 'AudienceCTA'
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-universal-footer {
  width: 100%;
  box-sizing: border-box;
}
</style>
